import { useEffect, useState, useCallback } from "react";
/* -------- Components -------- */
import Header from "./Header";
import Navbar from "./Navbar";
/* -------- ------- -------- */

/* -------- packages -------- */
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { fetchParameters, fetchUserRequest } from "../../store/actions";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
/* -------- ------- -------- */

import { checkTokenExpired, setSession, tokenConfig } from "../../utils/utils";

export default function Layout ({children}) {
    
    const body = document.querySelector("body");
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const parameters = useSelector((state) => state.Parameters);

    const [collpaseNavbar, setCollapseNavbar] = useState(false);
    const [tokenAlert, setTokenAlert] = useState(false);

    const closeSidebar = (e) => {
        if(body.classList.contains("sidebar-enable")) {
            body.classList.remove("sidebar-enable");
        }
    };

    const checkConnection = useCallback(() => {
        const token = checkTokenExpired();
        
        if(token.session) {
            if (!tokenAlert) {
                try {
                    toast.warning(
                        `${t('sessionExpired')} ${tokenConfig.delayAlert} min`,
                        {
                            position: "top-center",
                            autoClose: 8000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        }
                    );
                    setTokenAlert(true);
                } catch (error) {
                    console.error('Toast error:', error);
                }
            }
        } else if (token.logout) {
            try {
                toast.error(
                    `${t('sessionExpired')}`,
                    {
                        position: "top-center",
                        autoClose: 20000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    }
                );
                setTimeout(() => {
                    setSession(null);
                }, 20000);
            } catch (error) {
                console.error('Toast error:', error);
            }
        }
    }, [tokenAlert, t, location]);


    useEffect(() => {
        // Immediately check connection on component mount
        checkConnection();
        
        // Set up interval for periodic checks
        const intervalId = setInterval(checkConnection, 30000);
        
        return () => {
            clearInterval(intervalId);
        };
    }, [checkConnection]);

    useEffect( () => { // check if parameters.json is loaded
        if (!parameters.logoIcon || !parameters.logo) {
            fetch('/parameters.json').then(response => response.json()).then( (data) => {
            if(data) {
                dispatch(fetchParameters(data))
            } else {
                return
            }
            }).catch((error) => {
            console.error('Parameters.json not found, error:', error)
            })
        }
    }, [])

    const toggleNavbarMenu = (props) => {
        if(props == "closeClick") {
            return setCollapseNavbar(false)
        } 
        
        setCollapseNavbar(!collpaseNavbar);
    };

    const closeSubMenuNavbar = (e) => {
        const subMenuNavbars = document.querySelectorAll(".navbar-nav .nav-item .dropdown-menu");
        subMenuNavbars.forEach(subMenuNavbar => {
            if(subMenuNavbar.classList.contains("show")) {
                subMenuNavbar.classList.remove("show");
            }
        });
    };

    useEffect(() => {

        closeSidebar();
        closeSubMenuNavbar();
        
        const page = document.querySelector(".page-content");
        const navLinks = document.querySelectorAll(".nav-link");

        if (page) {
            page.addEventListener("click", closeSidebar);
            page.addEventListener("click", closeSubMenuNavbar);
            page.addEventListener("click", () => toggleNavbarMenu("closeClick"));
            navLinks.forEach(link => {
                link.addEventListener("click", () => toggleNavbarMenu("closeClick"));
            });
        }

        return () => {
            if (page) {
                page.removeEventListener("click", closeSidebar);
                page.removeEventListener("click", closeSubMenuNavbar);
                page.removeEventListener("click", () => toggleNavbarMenu("closeClick"));
                navLinks.forEach(link => {
                    link.removeEventListener("click", () => toggleNavbarMenu("closeClick"));
                });
            }
        };
    }, [location]);

    return ( 
        <div id="layout-wrapper">
            <Header toggleNavbarCallback={toggleNavbarMenu} isNavbarOpen={collpaseNavbar}/>
            <Navbar isNavbarOpen={collpaseNavbar}/>

            <div className="main-content">
                {children}
            </div>
            
            <ToastContainer
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                containerId="toastContainerLayout"
            />
        </div>
    )
}
